import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.stack.animation.slide
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimation
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import tta.destinigo.talktoastro.bottom_navigation.BottomNavigationPage
import tta.destinigo.talktoastro.core.navigation_decompose.root_component.RootComponent
import tta.destinigo.talktoastro.feature_article.persentation.post_page.ArticlePage
import tta.destinigo.talktoastro.feature_authentication.persentation.login_page.loginPage
import tta.destinigo.talktoastro.feature_authentication.persentation.otp_validation_page.OtpValidationPage
import tta.destinigo.talktoastro.feature_authentication.persentation.register_page.RegisterPage
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info.CallConsultationBottomSheet
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_consultation_options.CallConsultationOptionScreen
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_waitting_sucess.CallWaitingSuccess
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.JoinQueueBottomSheet
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet.QueueStatusBottomsheet
import tta.destinigo.talktoastro.feature_call_consultation.persentation.voip_call_page.VoIPCallConsultationScreen
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_bottom_sheet_info.ChatConsultationBottomSheet
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_host.ChatHostPage
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_queue_bottom_sheet_info.ChatQueueConsultationBottomSheet
import tta.destinigo.talktoastro.feature_course.persentation.course_page.CoursePage
import tta.destinigo.talktoastro.feature_course.persentation.course_preview_video.WinywayCourseScreen
import tta.destinigo.talktoastro.feature_course.persentation.course_video.CourseLessons
import tta.destinigo.talktoastro.feature_course.persentation.courses_page.CoursesPage
import tta.destinigo.talktoastro.feature_custom_order.persentation.CustomHostPage
import tta.destinigo.talktoastro.feature_custom_order.persentation.custom_order_details.CustomOrderDetailScreen
import tta.destinigo.talktoastro.feature_expert_details.persentation.expert_detail_page.ExpertDetails
import tta.destinigo.talktoastro.feature_expert_listing.presentation.ExpertListPage
import tta.destinigo.talktoastro.feature_expert_search.DisplaySearchExpertList
import tta.destinigo.talktoastro.feature_home.presentation.notificationsScreen.NotificationsScreen
import tta.destinigo.talktoastro.feature_post.persentation.PostDetails
import tta.destinigo.talktoastro.feature_post.persentation.PostList
import tta.destinigo.talktoastro.feature_profile.MoreScreenTab
import tta.destinigo.talktoastro.feature_profile.about_us.AboutUsScreen
import tta.destinigo.talktoastro.feature_profile.chat_history.ChatHistoryScreen
import tta.destinigo.talktoastro.feature_profile.chat_history.widget.ChatConversationComponentUI
import tta.destinigo.talktoastro.feature_profile.contact_us_screen.ContactUsScreen
import tta.destinigo.talktoastro.feature_profile.edit_profile.EditProfileScreen
import tta.destinigo.talktoastro.feature_profile.favourites.persentation.FavoriteScreen
import tta.destinigo.talktoastro.feature_profile.privacy_policy.PrivacyPolicyPage
import tta.destinigo.talktoastro.feature_profile.purchase_history.PurchaseHistory
import tta.destinigo.talktoastro.feature_profile.refer_and_earn.ReferEarnScreen
import tta.destinigo.talktoastro.feature_profile.terms_and_conditions_page.TermsAndConditions
import tta.destinigo.talktoastro.feature_profile.transaction_history.persentation.TransactionHistory
import tta.destinigo.talktoastro.feature_wallet.persentation.razorpay_gateway_new.StartGatewayPage
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_checkout.RechargeCheckout
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_failure.RechargeFailure
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_getway.PaymentGatewayPage
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_pack.ChooseRechargePack
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_payment_success.RechargeSuccess
import tta.destinigo.talktoastro.shared.persentation.ExitConfirmationDialog
import tta.destinigo.talktoastro.shared.persentation.dialog.NotificationPermissionDialog
import tta.destinigo.talktoastro.shared.persentation.image_viewer.FullScreenImageDialog
import tta.destinigo.talktoastro.shared.persentation.login_dialog.LoginPromptDialog
import tta.destinigo.talktoastro.version_info.getAppVersionInfo

@Composable
fun App(
    darkTheme: Boolean,
    dynamicColor: Boolean,
    rootComponent: RootComponent,
) {

    val childStack by rootComponent.stack.subscribeAsState()
    val dialogStack by rootComponent.dialog.subscribeAsState()

    dialogStack.child?.instance?.let { child ->
        when (child) {
            is RootComponent.DialogChild.LoginChild -> LoginPromptDialog(child.component)
            is RootComponent.DialogChild.OtpValidationChild -> TODO()
            is RootComponent.DialogChild.QueueDialogChild -> JoinQueueBottomSheet(child.component)
            is RootComponent.DialogChild.RegistrationChild -> TODO()
            is RootComponent.DialogChild.QueueStatusDialogChild -> QueueStatusBottomsheet(child.component)
            is RootComponent.DialogChild.ExitDialog -> ExitConfirmationDialog(child.component)
            is RootComponent.DialogChild.CallDurationDialogChild -> CallConsultationBottomSheet(
                child.component
            )

            is RootComponent.DialogChild.CallOptionDialogChild -> TODO()
            is RootComponent.DialogChild.ChatDurationDialogChild -> ChatConsultationBottomSheet(
                child.component
            )

            is RootComponent.DialogChild.ChatQueueJoinDialog -> ChatQueueConsultationBottomSheet(
                child.component
            )

            is RootComponent.DialogChild.PermissionDialogChild -> NotificationPermissionDialog(child.component)

            is RootComponent.DialogChild.ImageViewerDialogChild -> FullScreenImageDialog(child.component)
        }
    }

    Children(
        stack = childStack, animation = stackAnimation(slide())
    ) { child ->

        when (val instance = child.instance) {

            /*feature_authentication*/
            is RootComponent.Child.LoginPage -> loginPage(instance.component)
            is RootComponent.Child.OtpValidationPage -> OtpValidationPage(instance.component)
            is RootComponent.Child.RegistrationPage -> RegisterPage(instance.component)

            is RootComponent.Child.ExpertListPage -> ExpertListPage(instance.component)
            is RootComponent.Child.ExpertDetailsPage -> ExpertDetails(instance.component)
//            is RootComponent.Child.HomeScreenTab -> HomeScreenTab(instance.component)
            is RootComponent.Child.MoreScreenTab -> MoreScreenTab(
                instance.component, getAppVersionInfo()
            )

            is RootComponent.Child.ChoseRechargePage -> ChooseRechargePack(instance.component)
            is RootComponent.Child.StartGatewayChild -> StartGatewayPage(instance.component)
            is RootComponent.Child.RechargeCheckout -> RechargeCheckout(instance.component)
            is RootComponent.Child.PaymentGateway -> PaymentGatewayPage(instance.component)
            is RootComponent.Child.RechargeFailure -> RechargeFailure(instance.component)
            is RootComponent.Child.RechargeSuccess -> RechargeSuccess(instance.component)
            is RootComponent.Child.ChatHostChild -> ChatHostPage(instance.component)
            is RootComponent.Child.CallConsultationInfo -> CallConsultationBottomSheet(instance.component)
            is RootComponent.Child.CallConsultationOptions -> CallConsultationOptionScreen(
                instance.component
            )

            is RootComponent.Child.CallPlaceSuccess -> CallWaitingSuccess(instance.component)
            is RootComponent.Child.CallWaitingSuccess -> CallWaitingSuccess(instance.component)
            is RootComponent.Child.VoIPCall -> VoIPCallConsultationScreen(instance.component)
            is RootComponent.Child.ArticleDetailPage -> ArticlePage(instance.component)
            is RootComponent.Child.CustomOrderDetails -> CustomOrderDetailScreen(instance.component)
            is RootComponent.Child.CustomOrderPage -> CustomHostPage(instance.component)
            is RootComponent.Child.TransactionHistory -> TransactionHistory(instance.component)
            is RootComponent.Child.ChatHistory -> ChatHistoryScreen(instance.component)
            is RootComponent.Child.ChatConversationScreen -> ChatConversationComponentUI(instance.component)
            is RootComponent.Child.PrivacyPolicyPage -> PrivacyPolicyPage(instance.component)
            is RootComponent.Child.TermsAndConditions -> TermsAndConditions(instance.component)
            is RootComponent.Child.EditProfileScreen -> EditProfileScreen(instance.component)
            is RootComponent.Child.PurchaseHistory -> PurchaseHistory(instance.component)
            is RootComponent.Child.ReferAndEarn -> ReferEarnScreen(instance.component)
            is RootComponent.Child.PostScreen -> PostList(instance.component)
            is RootComponent.Child.PostDetailsScreenChild -> PostDetails(instance.component)
            is RootComponent.Child.DisplaySearchExpertList -> DisplaySearchExpertList(instance.component)
            is RootComponent.Child.FavoriteScreenChild -> FavoriteScreen(instance.component)
            is RootComponent.Child.ArticleHostChild -> TODO()
            is RootComponent.Child.CoursePageChild -> CoursePage(instance.component)
            is RootComponent.Child.CoursesPageChild -> CoursesPage(instance.component)
            is RootComponent.Child.AboutUs -> AboutUsScreen(instance.component)
            is RootComponent.Child.ContactUs -> ContactUsScreen(instance.component)
            is RootComponent.Child.BottomNavigationChild -> BottomNavigationPage(instance.component)
            is RootComponent.Child.CourseVedio -> WinywayCourseScreen(instance.component)
            is RootComponent.Child.CourseLessonChild -> CourseLessons(instance.component)
            is RootComponent.Child.NotificationClid -> NotificationsScreen(instance.component)
        }
    }

}



